<!--CONTENIDO ITEM DATOS DEMANDADO-->
<ng-container>
    <div class="wrapper__form">
      <app-form
        [title]="comunText['datos-demandado']  | translate"
        [fields]="formFieldDemandado"
        [withSubmitButton]="false"
        (changedControl)="onChangeValidarFormulario($event)"
        [idEntidad]="entidadId" />
      <br />
  
      <div class="d-flex flex-wrap justify-content-end gap-2 mt-md-5 mt-3">
        <button
          type="submit"
          class="btn-govco fill-add-govco mt-3"
          [disabled]="habilitarBtnAgregar()"
          (click)="agregarDemandado()"
          [attr.aria-label]="sfcText['tramite-sic-comp-desleal']['guardar-demandado']">
          {{ sfcText['tramite-sic-comp-desleal']['guardar-demandado'] }}
        </button>
      </div>
  
      <app-table
        [estiloEncabezado]="'height: auto !important;'"
        *ngIf="dataTableDemandado.length > 0"
        id="tblDemandantedataTableDemandado"
        [acciones]="actions"
        (eventoAccion)="borrarDemandado($event)"
        [datos]="dataTableDemandado"
        [columnas]="columnsDemandado"
        [paginacion]="false" />
      <br />
      <br />
    </div>
  
    <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
      <div class="d-flex flex-column flex-md-row gap-2">
        <button
          type="submit"
          class="btn-govco fill-before-btn-govco w-auto"
          onClick="nextItemAdvanceLineIHorizonalBack(event)"
          (click)="atras()"
          [attr.aria-label]="sfcText['botones-envio']['atras']">
          {{ sfcText['botones-envio']['atras'] }}
        </button>
        <button
          type="submit"
          class="btn-govco fill-btn-govco w-auto"
          (click)="pasarADetalle($event, true)"
          [attr.aria-label]="sfcText['botones-envio']['guardar-sin-enviar']">
          {{ sfcText['botones-envio']['guardar-sin-enviar'] }}
        </button>
        <button
          type="submit"
          class="btn-govco fill-next-btn-govco w-autos"
          (click)="pasarADetalle($event, false)"
          [attr.aria-label]="sfcText['siguiente']">
          {{ sfcText['siguiente'] }}
        </button>
      </div>
    </div>
  </ng-container>